<template>
    <section class="recover-pswd-comp">
        <SwipeModalComponent v-if="recoverPasswordMenu.isVisible" @closeMenu="changeRecoverPasswordMenuVisibility">
            <div class="content-wrapper">
                <div class="stripe"></div>
                <h2> Recuperar Senha </h2>

                <div>
                    <div class="menu-itens-container" v-for="(element, elkey) in formData" :key="elkey">
                        <label :for="getId(element.display)" v-text="element.display"></label>
                        <input :name="element.type" :id="getId(element.display)" :type="element.type" :placeholder="element.placeHolder" v-model="txtLogin"/>
                    </div>
                    <div class="footer-itens-container" v-if="!loading">
                        <h1 @click="recoverPassword">Confirmar</h1>
                    </div>
                    <div  class="footer-itens-container" v-else>
                        <h1>
                            Verificando dados
                            <!-- <i class="fas fa-spinner fa-spin"></i> -->
                            <fa :icon="['fas', 'spinner']" spin></fa>
                        </h1>
                    </div>
                </div>
            </div>
        </SwipeModalComponent>
        <ModalInfo></ModalInfo>
    </section>
</template>
<script>
import ModalInfo from '@/components/modals/ModalInfo.vue'
import SwipeModalComponent from './SwipeModalComponent.vue'
import Util from '@/assets/libs/util'
import { forgotPassword } from '@/assets/controllers/LoginController'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'RecoverPasswordMenu',
  components: {
    ModalInfo,
    SwipeModalComponent
  },
  data () {
    return {
      txtLogin: '',
      formData: [
        {
          placeHolder: 'E-mail',
          display: 'Informe seu E-mail',
          required: true,
          type: 'email'
        }
      ],
      buttons: [
        {
          icon: '',
          display: 'Confirmar',
          action: this.recoverPassword
        }
      ],
      loading: false,
      showStoreOptionsModal: false
    }
  },
  computed: {
    ...mapGetters(['recoverPasswordMenu', 'getSelectedLoginOption'])
  },
  methods: {
    ...mapActions(['changeRecoverPasswordMenuVisibility', 'setRecoverPasswordData', 'resetRecoverPasswordFormData',
      'showModalInfo', 'setLoginStoreOptions']),

    getId: function (display) {
      return display.replaceAll(' ', '').toLowerCase()
    },
    recoverPassword: function () {
      if (this.txtLogin) {
        this.loading = true
        forgotPassword(this.txtLogin).then((res) => {
          console.log(res)
          this.loading = false
          if (res.error) {
            Util.showErrorNotification({
              title: res.message || 'Não foi possível enviar o código de recuperação para ' + this.txtLogin,
              text: ''
            })
            this.changeRecoverPasswordMenuVisibility()
            return
          }
          if (!res.error && res.data) {
            const msg = res.data?.result || 'Email enviado com sucesso. Sigas as instruções para recuperar sua senha'
            this.showModalInfo(
              {
                type: 'success',
                text: msg,
                open: true
              }
            )
            this.changeRecoverPasswordMenuVisibility()
          } else {
            Util.showErrorNotification({
              title: 'Não foi possível enviar o código de recuperação para ' + res.email,
              text: ''
            })
            this.changeRecoverPasswordMenuVisibility()
          }
        })
      } else {
        Util.showWarningNotification({
          title: 'Informe o e-mail para recuperação de senha',
          text: ''
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.content-wrapper {
    max-width: 100%;

    h2 {
        text-align: center;
        font-size: 20px;
        &:last-of-type {
            margin-bottom: 30px;
        }
    }
    .select-container {
        padding: 5px;
        .select {
            padding: 5px;
            width: 100%;
            height: 30px;
            border: solid #BAB8B8 2px;
            border-radius: 5px;
            padding: 0 10px;
            font-size: 18px;
            margin: 15px auto;
            &:focus {
                outline: none;
            }

            option {
                font-size: 14px;
            }
        }

    }

    .menu-itens-container {
        padding: 5px;
        margin-top: 15px;
        overflow: auto;
        label {
            display: block;
            position: relative;
            margin-bottom: 15px;
        }
        input:not([type="checkbox"]) {
            width: calc(100% - 20px);
            border-radius: 7px;
            padding: 15px 10px;
            border: 1px solid #00000033;
            font-size: 18px;
        }

    }
    .footer-itens-container {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        h1 {
            color: var(--primaryColor);
            font-size: 16px;
            font-weight: 600;
            margin: 25px 15px 30px 15px;
        }
        button {
            text-align: right;
            border-radius: 30px;
            color: var(--primaryColor);
            padding: 10px 0;
            margin: 10px 15px 20px 15px;
            font-weight: 600;
            border: none;
            background-color: transparent;
        }
    }
}
</style>
